module.exports = __webpack_public_path__ + "static/media/icon-add.8f59e120.svg";